const defaultState = {
  users: null,
};

const usersReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_USERS':
      return {
        ...state,
        users: action.users,
      };
    default:
      return state;
  }
};

export default usersReducer;
